import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'
import Home from '../views/home.vue'
import Record from '../views/record.vue'
import Admin from '../views/admin.vue'
import User from '@/views/user.vue'
import Swap from '@/views/swap.vue'

import Page503 from '../views/503.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: 'home',
    children: [
      {
        path: 'home',
        component: Home,
        name: 'Home',
      },
      {
        path: 'record',
        component: Record,
        name: 'Record',
      },
      {
        path: 'admin',
        component: Admin,
        name: 'Admin',
      },
      {
        path: 'user',
        component: User,
        name: 'user',
      },
      {
        path: 'swap',
        component: Swap,
        name: 'swap',
      },
    ],
  },
  {
    path: '/503',
    component: Page503,
    name: '提示',
  },
]

const router = new VueRouter({
  routes,
})

export default router
